import { OfferDto } from "@intelligems/ig-types";

import { ScriptCampaignInput } from "../../types/checkoutScriptGenerator";

export const getDiscountInput = (discount: OfferDto): ScriptCampaignInput => {
  return discount.discountType === "percentage"
    ? ":percent"
    : discount.discountApplicationMethod === "perItem"
      ? ":per_item"
      : ":fixed";
};
